<template>
  <v-content class="spinelab-website-front">
    <v-container>
      <v-flex xs12 sm12 md12>
        <h1 class="text-sm-left">お問合せ一括管理</h1>
      </v-flex>
      <v-layout row wrap>
          <v-menu lazy
                  :close-on-content-click="false"
                  :nudge-right="40"
                  min-width="290px"
                  transition="scale-transition"
                  offset-y>
            <v-text-field slot="activator"
                          label="月を選択"
                          prepend-icon="event"
                          :value="displayMonth"
                          readonly>
            </v-text-field>
            <v-date-picker v-model="date"
                           type="month"
                           no-title
                           locale="ja_JP"
                           :year-format="yearFormat"
                           :month-format="monthFormat"
                           :min="minDay"
                           :max="maxDay"
                           :class="`spinelab-website-front ${$style['admin-contacts-csv']}`">
            </v-date-picker>
          </v-menu>
        <v-subheader>
          のお問合せデータを
        </v-subheader>
        <v-btn color="success"
               @click="download"
               :disabled="!date"
               :loading="downloading">
          CSV一括ダウンロード
        </v-btn>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
import { mapState } from 'vuex';
import { saveAs } from 'file-saver';
import { convert } from 'encoding-japanese';

export default {
  name: 'AdminContactsCSV',
  data() {
    return {
      date: null,
      downloading: false,
    };
  },
  computed: {
    ...mapState({
      requests: state => state.requests,
    }),
    displayMonth() {
      if (!this.date) {
        return '';
      }
      const year = this.yearFormat(this.date);
      const month = this.monthFormat(this.date);
      return `${year}${month}`;
    },
    minDay() {
      return '2018-01-01';
    },
    maxDay() {
      return this.today;
    },
    today() {
      const d = new Date();
      const year = d.getFullYear();
      const month = `0${d.getMonth() + 1}`.slice(-2);
      const day = `0${d.getDate()}`.slice(-2);
      return `${year}-${month}-${day}`;
    },
  },
  methods: {
    async download() {
      this.downloading = true;
      const d = new Date(this.date);
      const year = d.getFullYear();
      const month = d.getMonth() + 1;
      const csv = await this.requests.getAdminAllContacts(year, month);
      const sjisCSV = new Uint8Array(convert(csv, {
        to: 'SJIS',
        from: 'AUTO',
        type: 'array',
      }));
      const blob = new Blob([sjisCSV], { type: 'text/csv' });
      saveAs(blob, 'contacts.csv');
      this.downloading = false;
    },
    yearFormat(date) {
      return `${new Date(date).getFullYear()}年`;
    },
    monthFormat(date) {
      return `${new Date(date).getMonth() + 1}月`;
    },
  },
};
</script>

<style lang="scss" module>
.admin-contacts-csv {
    td {
        padding: 0px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/ContactsCSV.vue